<main class="px-8 xl:px-0 py-16">

			<section id="sign-up" class="container mx-auto max-w-screen-xl prose leading-normal">
				<div class="sign-up__intro">
					<h1 class="header-hex-bar"><span class="inline-block">Sign Up</span></h1>
					<p>To participate, complete and submit the form below on or before <em>March 10th, 2025</em>, and start earning rewards, including a <em>YETI<sup>&reg;</sup> LoadOut<sup>&reg;</sup> Bucket</em> just for joining!</p>
				</div>
				<div class="sign-up__terms">
                    <p><a data-measurement="SSP - Sign Up - Program Information PDF" href="https://assets.syngentaebiz.com/pdf/media/storen-satisfaction-program-sheet.pdf" target="_blank" download>Program information and reward details (PDF)</a></p>
				</div>
                <form #signUpform='ngForm'>
				<div class="sign-up__grower-details grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8"  #signUp_intro>
					<label for="firstName" class="block">
						<span><span class="required-asterisk">*</span>First Name</span>
						<input id="firstName"  #first  name="firstName" type="text" class="mt-1 block w-full" placeholder="" required [(ngModel)]="firstName" />
					</label>
					<label for="lastName" class="block">
						<span><span class="required-asterisk">*</span>Last Name</span>
						<input id="lastName" name="lastName" type="text" class="mt-1 block w-full" placeholder="" required [(ngModel)]="lastName"/>
					</label>
					<label for="emailAddress" class="block">
						<span><span class="required-asterisk">*</span>Email Address</span>
						<input id="emailAddress" name="emailAddress" type="email" #Email class="mt-1 block w-full" placeholder="" required  [(ngModel)]="email"  (focusout)="validateEmailExist($event)"/>
						<span class="text-red-500" *ngIf="showEmailErr">{{showEmailMsg}}</span>
					</label>
					<label for="phoneNumber" class="block">
						<span><span class="required-asterisk">*</span>Phone Number</span>
						<input id="phoneNumber" name="phoneNumber" type="tel" class="mt-1 block w-full" placeholder="" required pattern="^[0-9]{10}" minlength="10" maxlength="10"  [(ngModel)]="selectedPhoneNum"/>
					</label>
					<label for="occupation" class="block">
						<span><span class="required-asterisk">*</span>Occupation</span>
						<!-- <input id="occupation" name="occupation" type="text" class="mt-1 block w-full" placeholder="" required /> -->
						<select class="form-input mt-1 block w-full" id="occupation" name="occupation" required [(ngModel)]="occupation" >
							<!-- <option disabled="disabled" selected="selected" value=""></option> -->
							<option value="Grower">Grower</option>
							<option value="Retailer">Retailer</option>
							<option value="Both">Both</option>
						</select>
					</label>
					<label for="mailingAddress" class="block">
						<span><span class="required-asterisk">*</span>Mailing Address <span class="text-gray-400">(No P.O. Boxes)</span></span>
						<input id="mailingAddress" name="mailingAddress" [(ngModel)]="mailaddress" type="text" class="mt-1 block w-full" placeholder="" required />
					</label>
					<label for="city" class="block">
						<span><span class="required-asterisk">*</span>City</span>
						<input id="city" name="city" type="text" class="mt-1 block w-full" placeholder="" required [(ngModel)]="selectedcity" />
					</label>
					<label for="state" class="block">
						<span><span class="required-asterisk">*</span>State</span>
						<select class="form-input mt-1 block w-full" id="state" name="state" required [(ngModel)]="selectedState">
							<!-- <option disabled="disabled" selected="selected" value=""></option> -->
							<option value="Alabama">Alabama</option>
							<option value="Alaska">Alaska</option>
							<option value="Arizona">Arizona</option>
							<option value="Arkansas">Arkansas</option>
							<option value="California">California</option>
							<option value="Colorado">Colorado</option>
							<option value="Connecticut">Connecticut</option>
							<option value="Delaware">Delaware</option>
							<option value="District Of Columbia">District Of Columbia</option>
							<option value="Florida">Florida</option>
							<option value="Georgia">Georgia</option>
							<option value="Hawaii">Hawaii</option>
							<option value="Idaho">Idaho</option>
							<option value="Illinois">Illinois</option>
							<option value="Indiana">Indiana</option>
							<option value="Iowa">Iowa</option>
							<option value="Kansas">Kansas</option>
							<option value="Kentucky">Kentucky</option>
							<option value="Louisiana">Louisiana</option>
							<option value="Maine">Maine</option>
							<option value="Maryland">Maryland</option>
							<option value="Massachusetts">Massachusetts</option>
							<option value="Michigan">Michigan</option>
							<option value="Minnesota">Minnesota</option>
							<option value="Mississippi">Mississippi</option>
							<option value="Missouri">Missouri</option>
							<option value="Montana">Montana</option>
							<option value="Nebraska">Nebraska</option>
							<option value="Nevada">Nevada</option>
							<option value="New Hampshire">New Hampshire</option>
							<option value="New Jersey">New Jersey</option>
							<option value="New Mexico">New Mexico</option>
							<option value="New York">New York</option>
							<option value="North Carolina">North Carolina</option>
							<option value="North Dakota">North Dakota</option>
							<option value="Ohio">Ohio</option>
							<option value="Oklahoma">Oklahoma</option>
							<option value="Oregon">Oregon</option>
							<option value="Pennsylvania">Pennsylvania</option>
							<option value="Rhode Island">Rhode Island</option>
							<option value="South Carolina">South Carolina</option>
							<option value="South Dakota">South Dakota</option>
							<option value="Tennessee">Tennessee</option>
							<option value="Texas">Texas</option>
							<option value="Utah">Utah</option>
							<option value="Vermont">Vermont</option>
							<option value="Virginia">Virginia</option>
							<option value="Washington">Washington</option>
							<option value="West Virginia">West Virginia</option>
							<option value="Wisconsin">Wisconsin</option>
							<option value="Wyoming">Wyoming</option>
						</select>
					</label>
					<label for="zipCode" class="block">
						<span><span class="required-asterisk">*</span>Zip Code</span>
						<input id="zipCode" name="zipCode" type="tel" class="mt-1 block w-full" placeholder="" required minlength="5" [(ngModel)]="selectedZip" maxlength="5" pattern="^[0-9]{5}" />
					</label>
					<label for="rafCode" class="block" id="rafCodeValid">
						<span>Refer-a-Friend Code <span class="text-gray-400">(Optional)</span></span>
						<input id="rafCode" name="rafCode" #RAFcode type="text" class="mt-1 block w-full uppercase font-mono slashed-zero" [(ngModel)]="referaFriend" placeholder="" minlength="4" maxlength="4" #ReferCode="ngModel" pattern="^[a-zA-Z0-9]{4}" (focusout)="ValidRAFcode($event)"/>
						<div *ngIf="ReferCode.invalid && (ReferCode.dirty || ReferCode.touched)" class="text-red-500">
							<div *ngIf="ReferCode.errors?.['minlength']">Referral code must be 4 characters in length and contain no special characters.</div>
                            <div *ngIf="ReferCode.errors?.['maxlength']">Valid Referral code cannot be more than 4 characters long.</div>
							<div *ngIf="ReferCode.errors?.['pattern']">Please enter Valid Referral code.</div>
						</div>
						<div class="text-red-500" *ngIf="showReffer">{{referMsgDisplay}}</div>
					</label>
					<!-- <label for="password" class="block" *ngIf="!hidePasswordField"> -->
						<!-- <label for="password" class="block" [ngStyle]="{'display': !hidePasswordField ?'block':'none'}"> -->
						<label for="password" class="block" [ngStyle]="{'display': !hidePasswordField ?'block':'none'}">
						<span><span class="required-asterisk">*</span>Choose a password</span>
						<input id="password" name="password" #passI type="password" class="mt-1 block w-full" placeholder="" [required]="reQuid"  [(ngModel)]="selectedPassword" minlength="8" maxlength="20" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@#$!%*?&]{8,20}$" (focusout)="validPassword($event)" #passwordInput="ngModel"/>
						<div *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)" class="text-red-500">
                            <div *ngIf="passwordInput.errors?.['required']">Password is required.</div>
                            <div *ngIf="passwordInput.errors?.['minlength']">Password must be at least 8 characters long.</div>
                            <div *ngIf="passwordInput.errors?.['maxlength']">Password cannot be more than 20 characters long.</div>
                            <div *ngIf="passwordInput.errors?.['pattern']">Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.</div>
                        </div>
						<div *ngIf="showErrPass" class="text-red-500">{{showErrPassMsg}}</div>

					</label>
					<label for="passwordConfirm" class="block" [ngStyle]="{'display': !hidePasswordField ?'block':'none'}">
						<span><span class="required-asterisk">*</span>Re-enter your password</span>
						<input id="passwordConfirm" name="passwordConfirm" #confirmI type="password" class="mt-1 block w-full" placeholder="" [required]="reQuid"  #Confirm="ngModel"  (focusout)="validConfirm()" [(ngModel)]="confirmPassword"/>
						<div *ngIf="Confirm.touched && selectedPassword !== confirmPassword" class="text-red-500">Passwords do not match</div>
					</label>
				</div>
				<div class="sign-up__consent grid grid-cols-1 sm:grid-cols-2 gap-6 my-6">
					<div class="block">
						<div class="mt-2">
							<div>
								<label for="consentEmail" class="inline-flex items-center">
									<input id="consentEmail" name="consentEmail" type="checkbox" required  [(ngModel)]="emailNotify"/>
									<span class="ml-2"><span class="required-asterisk">*</span>I agree to receive email notifications about the Storen Satisfaction Program.</span>
								</label>
							</div>
						</div>
					</div>
					<div class="block">
						<div class="mt-2">
							<div>
								<label for="consentSMS" class="inline-flex items-center">
									<input id="consentSMS" name="consentSMS" type="checkbox" requried [(ngModel)]="smsNotify"/>
									<span class="ml-2"><span class="required-asterisk">*</span>I agree to receive SMS text notifications about the Storen Satisfaction Program.</span>
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="sign-up__terms">
                    <p class="text-center sm:text-left"><a data-measurement="SSP - Sign Up - Terms and Conditions PDF" href="https://assets.syngentaebiz.com/pdf/media/storen-satisfaction-program-rules.pdf" target="_blank" download>Terms and conditions (PDF)</a></p>
				</div>
				<div class="sign-up__legal">
					<p>Disclaimer: Upon receiving an initial text message from Syngenta, the cell phone user agrees to receive text message communications from Syngenta under the campaign. Standard text message rates apply and are the sole responsibility of the cell phone user. To stop receiving messages, the cell phone user must reply to a Syngenta text message with the message “STOP.”</p>
				</div>
		
				<!-- <span class="text-red-500">{{errorMsg}}</span> -->
				<div class="sign-up__submit">
					<button id="btnSubmit" type="button" class="btn__blue" data-measurement="SSP - Sign Up - Submit"(click)="signUpClick(signUpform)">Sign Up</button>
				</div>
            </form>
			</section>

		</main>

<!--Alert OOPS-->
		<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true" *ngIf="errStorenReg">
			<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
			<div class="fixed inset-0 z-10 w-screen overflow-y-auto">
			  <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
				<div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
				  <div class="bg-white text-center pt-4 pb-2">
						<p class="text-[18px] md:text-[18px] text-center pt-4">Oops! Something went wrong. Please try again later.</p>
				  </div>
				  <div class="bg-white-20 px-3 mt-3 mb-4 py-3 text-center">
					<button type="button" class="btn__blue closebtn" (click)="errStorenReg=false">Close</button>
				  </div>
				</div>
			  </div>		  
			</div>
		  </div>
		  